define.alias("shared/components/shared/social/instagram-modal/unavailable-page", "media/components/shared/social/instagram-modal/unavailable-page");